import React, { useEffect } from "react";
import { useState } from "react";
import { isMobile } from "react-device-detect";
import {
  Link,
  NavLink,
  useNavigate,
  useLocation,
  useOutletContext,
} from "react-router-dom";
import { FaTruckMoving, FaFile, FaCarSide, FaPlusCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, CircularProgress } from "@mui/material";
import apiClient from "../api/apiClient";

export default ({ user, vehicle, values }) => {
  const { userId } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);


  const[image,setimg]=useState()
  const { profile_url, setProfile_url } = values;
  useEffect(() => {
    const handleResize = () => {
      const mobileWidth = 950;
      console.log(window.innerWidth < mobileWidth);
      setIsMobile(window.innerWidth < mobileWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  
  const ProfileHandelChange = async(e) => {
    const file = e.target.files[0];
    setProfile_url(file); 

    const formData = new FormData();
  formData.append("profile_url", file); // Append the file, not the URL
  setimg("")
  const res = await apiClient.patch(`/authentication/accounts/${userId}/`, formData);
 
  fetch()
  };
  const [status, setstatus] = useState(false);
  const navigate = useNavigate();





const fetch= async()=>{
 
 const res= await apiClient.get(`/authentication/accounts/${userId}/`,)
console.log(res.data.profile_url,' wwwwwwwwwwwwwwwwwwwwwwww')
setimg(res.data.profile_url)
//  var hhh=res.data.profile_url

}




// const submit = async () => {
//   const formData = new FormData();
//   formData.append("profile_url", profile_url); 
//   const res = await apiClient.patch(`/authentication/accounts/${userId}/`, formData);
//   console.log(res, 'ee eeeeeeeeeeeeeee');
//   fetch();
// };

useEffect(() => {
 
  fetch();
}, []);



  return (
    <div>
      <div className="ps-0 ps-md-3  ">
        <div
          className=""
          style={{
            backgroundColor: "#015A96",
            borderTopLeftRadius: 20,
            borderBottomLeftRadius: 20,
          }}
        >
          {(status || !isMobile) && (
            <div
              className=" sidebar"
              style={{ height: "95vh", overflow: "auto" }}
            >
              <div className="side-bar-content pt-5 d-flex flex-wrap flex-column align-items-center">
                <div className="  profile_img">
                  <div
                    style={{ width: "5rem" }}
                    className=" img pb-2  border border-2 border-top-0 border-end-0 border-start-0 border-white"
                  >
                   

{/* <CircularProgress /> */}
 <Avatar  sx={{height:82,width:82}}   src={
                      
                      
                        image||
                        require("../assets/img/account-icon.png")
                      } />
                      

                  </div>
                    
                  <input
                    hidden
                    type="file"
                    name=""
                    id="uplod-profile"
                    onChange={ProfileHandelChange}
                  />
                  <label htmlFor="uplod-profile">
                    <FaPlusCircle className="img_icon" />
                  </label>
                </div>


             
                <div className="sidebar-links">
                  <ul className="list-unstyled sidebar_list  p-2">
                    <NavLink
                      className="text-white nav-link  "
                      to={"/vehicleowneraccount"}
                    >
                      <li
                        className="m-2 p-2"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/vehicleowneraccount')
                        }}
                      >
                        <i className="bi bi-person-fill " />
                        <span className="ps-2 fs-5">Account</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className={`text-white nav-link ${
                        location.pathname === "/vehicleowneraddvehicle"
                          ? "active"
                          : ""
                      }`}
                      to={"/vehicleownervehicle"}
                    >
                      <li
                        className="m-2 p-2"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/vehicleownervehicle')
                        }}
                      >
                        <FaCarSide />
                        <span className="ps-2 fs-5" >Vehicles</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className=" text-white nav-link d-flex align-items-center"
                      to={"/vehicleownerpayment"}
                    >
                      <li
                        className="m-2 mt-1 p-2"
                        onClick={() => {
                          setstatus(false);
                          navigate("/vehicleownerpayment");
                        }}
                      >
                        <i className="bi bi-credit-card-fill" />
                        <span className="ps-2 fs-5">Payment</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white nav-link"
                      to={"/vehicleownercampaigns"}
                    >
                      <li
                        className=" m-2 p-2"
                        onClick={() => {
                          setstatus(false);
                        }}
                      >
                        <FaTruckMoving />
                        <span className="ps-2 fs-5 ">Campaigns</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white d-flex align-items-center nav-link"
                      to={"/vehicleowner-request"}
                    >
                      <li
                        className="m-2 mt-1 p-2"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/vehicleowner-request')
                        }}
                      >
                        <i className="bi bi-chat-left-fill" />
                        <span className="ps-2 fs-5">Requests</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white d-flex align-items-center nav-link"
                      to={"/vehicle-owner-schedule"}
                    >
                      <li
                        className="m-2 mt-1 p-2"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/vehicle-owner-schedule')
                        }}
                      >
                        <i className="bi bi-calendar-fill" />
                        <span className="ps-2 fs-5">Schedule</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white d-flex align-items-center nav-link"
                      to={"/vehicleownersetting"}
                    >
                      <li
                        className="setting m-2 mt-1 p-2"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/vehicleownersetting')
                        }}
                      >
                        <i className="bi bi-gear-fill" />
                        <span className="ps-2 fs-5">Settings</span>
                      </li>
                    </NavLink>
                  </ul>
                </div>
              </div>
            </div>
          )}
          {isMobile && (
            <button style={{zIndex:"999999"}}
              onClick={() => setstatus(!status)}
              className="open-menu d-block  ms-auto text-white fs-2 border-0 bg-blue rounded-pill p-3 position-absolute top-0 end-0"
            >
              <i className="bi bi-list" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
